import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import styles from "../../stripe-dashboard.module.css";

function SubscriptionMomentumChart({ data }) {
  return (
    <div className={styles.chartCard}>
      <p className={styles.chartTitle}>Movimento de Assinaturas</p>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={data}>
          <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" />
          <XAxis
            dataKey="month"
            tick={{ fontSize: 11, fill: "#94a3b8" }}
            axisLine={false}
            tickLine={false}
          />
          <YAxis
            tick={{ fontSize: 11, fill: "#94a3b8" }}
            axisLine={false}
            tickLine={false}
          />
          <Tooltip
            contentStyle={{ background: "#0f172a", border: "none", borderRadius: 8, fontSize: 12 }}
            labelStyle={{ color: "rgba(255,255,255,0.6)" }}
            itemStyle={{ color: "#fff" }}
          />
          <Legend wrapperStyle={{ fontSize: 12, color: "#64748b" }} />
          <Bar dataKey="new"        stackId="a" name="Novas"         fill="#22c55e" />
          <Bar dataKey="upgrades"   stackId="a" name="Upgrades"      fill="#035184" />
          <Bar dataKey="downgrades" stackId="a" name="Downgrades"    fill="#f59e0b" />
          <Bar dataKey="churn"                  name="Cancelamentos" fill="#ef4444" radius={[4, 4, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}

export default SubscriptionMomentumChart;
